import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'
import { getSessionId } from '../../utils/helper'

export class CutomerService {
  async getApplicationbyMultipleId(programIds, pageNum, filter) {
    const headers = {
      headers: {
        'e-auth-token': getSessionId()
      }
    }
    try {
      const page = pageNum > 0 ? pageNum - 1 : 0
      const response = await service.get(Urls.getApiUrl(`application/all/view?program_ids=${(programIds).join(',')}&filter_status=${filter}&page_no=${page}&page_size=10`, MICROSERVICES.ENROLLMENTMANAGER), headers)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
  async getApplicationsByProgramId(programId, pageNum, filter) {
      const headers = {
        headers: {
          'e-auth-token': getSessionId()
        }
      }
      try {
        const page = pageNum > 0 ? pageNum - 1 : 0
        const response = (filter !== 'UNENROLLED') ?
          await service.get(Urls.getApiUrl(`application/applicationids/${programId}?filter_status=${filter}&page_no=${page}&page_size=10`, MICROSERVICES.ENROLLMENTMANAGER), headers):
          await service.get(Urls.getApiUrl(`application/${programId}/all-enrollments?page_no=${page}&page_size=10&status=${filter}&active=0`, MICROSERVICES.ENROLLMENTMANAGER), headers)
        const { data } = response
        return data.data
      } catch (e) {
        throw e
      }
  }

  async getApplicationsById(programId, applicationId) {
    const headers = {
      headers: {
        'e-auth-token': getSessionId()
      }
    }
    try {
      const response = await service.get(Urls.getApiUrl(`application/${applicationId}?programId=${programId}`, MICROSERVICES.ENROLLMENTMANAGER), headers)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateApplication(payload, method = 'post', applicationId) {
    let formData = new FormData()
    const json = JSON.stringify(payload)
    const blob = new Blob([json], {
      type: 'application/json',
    })
    formData.append('application_form', blob)

    try {
      const response = await service[method](Urls.getApiUrl(`application/${applicationId}`, MICROSERVICES.ENROLLMENTMANAGER), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateStatus(applicationId, body) {
    const headers = {
      headers: {
        'e-auth-token': getSessionId()
      }
    }
    try {
      const response = await service.put(Urls.getApiUrl(`application/${applicationId}/status/update`, MICROSERVICES.ENROLLMENTMANAGER), body, headers)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const customerService = new CutomerService()
